/* ******************************Role_id****************************** */

/* *Admin role* */
export const IS_ADMIN_ROLE = 2;

export const IS_ADMIN_READONLY_ROLE = 13;

/* *Activation role* */
export const IS_ACTIVATION_ROLE = 3;

export const IS_ACTIVATION_TEAM_ROLE = 26;

/* *Customer role* */
export const IS_CUSTOMER_ROLE = 6;

export const IS_CUSTOMER_READONLY_ROLE = 8;
export const IS_TECHNICAL_PARTNER_ROLE = 25;

/* *Sales role* */
export const IS_SALES_ROLE = 7;

export const IS_SALES_STAFF_ROLE = 21;
export const IS_SALES_READONLY_ROLE = 12;

/* *Distributor role* */
export const IS_DISTRIBUTOR_ROLE = 4;

export const IS_DISTRIBUTOR_READONLY_ROLE = 9;
export const IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE = 22;
export const IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE = 23;
export const IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE = 45;

/* *Reseller role* */
export const IS_RESELLER_ROLE = 5;

export const IS_RESELLER_CUSTOMER_ROLE = 34;
export const IS_RESELLER_CUSTOMER_READONLY_ROLE = 35;
export const IS_RESELLER_READONLY_ROLE = 38;

/* ******************************Role_name****************************** */

/* *Admin role-name* */
export const IS_ADMIN_NAME = "admin";

/* *Activation role-name* */
export const IS_ACTIVATION_NAME = "activation";

export const IS_ACTIVATION_TEAM_NAME = "activation_team";

/* *Customer role-name* */
export const IS_CUSTOMER_NAME = "customer";

export const IS_CUSTOMER_READONLY_NAME = "client_readonly";
export const IS_TECHNICAL_PARTNER_NAME = "technical_partner";

/* *Sales role-name* */
export const IS_SALES_NAME = "sales";

export const IS_SALES_STAFF_NAME = "sales_staff";

/* *Distributor role-name* */
export const IS_DISTRIBUTOR_NAME = "distributor";

export const IS_DISTRIBUTOR_READONLY_NAME = "Distributor_readonly";
export const IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE_NAME = "client_admin_d";
export const IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE_NAME = "Client_readonly_d";
export const IS_DISTRIBUTOR_CUSTOMER_OPERATOR_NAME = "client_operator_d";

/* *Reseller role-name* */
export const IS_RESELLER_NAME = "reseller";

export const IS_RESELLER_CUSTOMER_NAME = "Client_admin_r";
export const IS_RESELLER_CUSTOMER_READONLY_NAME = "Client_readonly_r";
